import { RESET_COMPARISON_SUCCESS } from '../Comparator/Comparator.actions'
import {
  COMPARATOR_PROVIDERS,
  COMPARATOR_PROVIDERS_SUCCESS,
  COMPARATOR_PROVIDERS_ERROR
} from './ComparatorProviders.actions'

const initialState = {
  data: {
    categories: [],
    chart: [],
    csv: []
  },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator Providers's reducer.
 */
const comparatorProvidersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARATOR_PROVIDERS: {
      return { ...state, fetching: true }
    }
    case COMPARATOR_PROVIDERS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          categories: payload.categories,
          chart: payload.chart,
          csv: payload.csv
        },
        fetched: true,
        fetching: false
      }
    }
    case COMPARATOR_PROVIDERS_ERROR: {
      return { ...state, error: payload.error }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorProvidersReducer
